import { GET_PATHOLOGY_AI_STUDIES } from '@custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';

const getPathologyAIStudies = createAsyncThunk('getPathologyAIStudies', async (hospitalId: string) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    const response = await fetch(`${GET_PATHOLOGY_AI_STUDIES}/${hospitalId}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await response.json();
  } catch (error) {
    return error;
  }
});

export default getPathologyAIStudies;
